import { Box, Flex, Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { ContactForm } from "./ContactForm";
import { EnvelopeClosedIcon } from "@radix-ui/react-icons";

export function ContactSection() {
  const { t } = useTranslation();

  return (
    <Box
      style={{
        backgroundColor: "#1e293b",
        borderRadius: "12px",
        padding: "2.5rem",
      }}
    >
      <Flex direction="column" gap="5">
        <Flex direction="column" gap="2" align="center">
          <Flex
            align="center"
            justify="center"
            style={{
              width: "56px",
              height: "56px",
              backgroundColor: "#334155",
              borderRadius: "50%",
            }}
          >
            <EnvelopeClosedIcon width="28" height="28" color="#38bdf8" />
          </Flex>
          <Heading size="6" style={{ color: "white", textAlign: "center" }}>
            {t("onePager.contact.title")}
          </Heading>
          <Text
            size="3"
            style={{
              color: "#94a3b8",
              textAlign: "center",
              maxWidth: "400px",
            }}
          >
            {t("onePager.contact.invite")}
          </Text>
        </Flex>

        <Box
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "1.5rem",
          }}
        >
          <ContactForm />
        </Box>
      </Flex>
    </Box>
  );
}
